import { Text, Tooltip, useMantineTheme } from "@mantine/core";
import { ReactElement, ReactNode } from "react";
import { TextWithTooltipProps } from "./types";
import { useStyles } from "./TextWithTooltip.styled";

export default function TextWithTooltip({
  content,
  ...textProps
}: TextWithTooltipProps): ReactElement {
  const theme = useMantineTheme();
  const { classes } = useStyles();

  let theContent: ReactNode[] = [content + ""];

  if (content.length) {
    const markdownLinks = content.match(/(\[(.*?)\])(\([^\]]*\))/gm);
    if (markdownLinks?.length) {
      markdownLinks.forEach((markdownLink, index) => {
        // [tooltipText](tooltipContent)
        const [tooltipText, tooltipContent] = markdownLink
          .substring(1, markdownLink.length - 1)
          .split("](");

        // theContent = [..., lastContentStr]
        const lastContentStr = theContent[theContent.length - 1];
        if (typeof lastContentStr === "string") {
          // lastContentStr = [beg, end]
          const lastContentStrSplit: ReactNode[] =
            lastContentStr.split(markdownLink);

          // lastContentStr = [beg, <Tooltip>, end]
          lastContentStrSplit.splice(
            1,
            0,
            <Tooltip
              key={index}
              arrowSize={theme.spacing.xs}
              color="dark"
              label={tooltipContent}
              multiline
              withArrow
              withinPortal
              maw={250}
            >
              <Text className={classes.tooltipLink} span>
                {tooltipText}
              </Text>
            </Tooltip>,
          );

          // theContent = [...]
          theContent.pop();

          // theContent = [..., beg, <Tooltip>, end]
          theContent = [...theContent, ...lastContentStrSplit];
        }
      });
    }
  }

  return <Text {...textProps}>{theContent}</Text>;
}
